<template>
    <rkm-overlay>
        <rkm-layout-body title="Paciente em observação">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/observacao/List'

export default {
    components: { List }
}
</script>